export class OpsUnit {
    id: string;
    vesselId: string;
    index: number;
    LineAIp: string;
    LineBIp: string;
    location: string;
    allCategoriesSelected: boolean;
    mountType: MountType;
    sunshade: boolean;
    EMC: boolean;
    ethernetExtraLength: boolean;
    keyboard: boolean;
    color?: string;
}

export enum MountType {
    UNDEFINED = 'undefined',
    CONSOLE = 'console',
    STAND = 'stand',
}

export const opsUnitmax = 17;

export const edgeOpsNum = 17;
export const edgeLineA = '192.168.60.17';
export const edgeLineB = '192.168.61.17';

export function createDefaultOpsUnit(index, vesselId, isEdge: boolean = false): OpsUnit {
    return {
        id: '',
        vesselId: vesselId,
        index: isEdge ? edgeOpsNum : index,
        LineAIp: isEdge ? edgeLineA : `192.168.60.${index}`,
        LineBIp: isEdge ? edgeLineB : `192.168.61.${index}`,
        location: isEdge ? 'iEdge' : '',
        allCategoriesSelected: true,
        mountType: MountType.CONSOLE,
        sunshade: false,
        EMC: false,
        ethernetExtraLength: false,
        keyboard: false,
        color: '',
    } as OpsUnit;
}
